import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Facture } from 'src/model/model.facture';
import { environment } from 'src/environments/environment';

@Injectable()
export class FactureService {

  basePath = environment.BasePath+"/survey";

  constructor(private httpClient: HttpClient) { }


  getFactures(motCle: string): Observable<any> {

    return this.httpClient.get(this.basePath + "/chercheFacture?nom="+motCle)
  }

  getLastFacture(): Observable<any> {
    return this.httpClient.get(this.basePath + "/lastFacture")

  }

  getAllFactures(): Observable<any> {

    return this.httpClient.get(this.basePath + "/facture")

  }

  getFactureById(id: number): Observable<any>{
    return this.httpClient.get(this.basePath + "/facture/"+id)

  }

  saveFacture(facture: Facture): Observable<any> {

    return this.httpClient.post(this.basePath + "/facture",facture)

  }

  convertToLettre(montant:number): Observable<any>{

    return this.httpClient.get(this.basePath + "/ConvertMtnEnLettre/"+ montant)
  }


  printJasper(id :number): Observable<any>{

    return this.httpClient.get(this.basePath + "/print/ExportFacturePdf/"+ id);
  }

}
